module.exports = __webpack_public_path__ + "img/newchris-55.34ef6a82.jpg";